import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

import Layout from './components/Layout';
import { initializeAnalytics } from './services/analytics';

const HomePage = lazy(() => import('./pages/HomePage'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const RestaurantPage = lazy(() => import('./pages/RestaurantPage'));
const SubmitPage = lazy(() => import('./pages/SubmitPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

if (process.env.NODE_ENV === 'production') {
  initializeAnalytics();
}

function PageFallback() {
  return (
    <div className="flex items-center justify-center min-h-[40vh]">
      <div className="animate-pulse text-gray-400">Loading…</div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="restaurant/:slug" element={<RestaurantPage />} />
            <Route path="submit" element={<SubmitPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
